import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { TreeselectOptionAdAccount } from '@/views/Automation/CampaignCreatorV2/types';

interface Props {
  node: { raw: TreeselectOptionAdAccount };
  mode?: 'value' | 'option';
  labelClassName?: string;
  checked: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TreeselectAccountOption.ts',
  props: {
    node: null,
    mode: { default: 'option' },
    labelClassName: { default: '' },
    checked: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,CcIcon }
}

})